module.exports = __webpack_public_path__ + "static/media/right-arrow.ee6493b6.svg";